import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Popconfirm, Card, Table, Space, Input,
    message,
    Spin
} from 'antd';
// import { getBusinesses } from "../../actions/BusinessActions";
import EditSeo from './EditSeo';
import AddSeo from './AddSeo';
import { isEmpty } from "lodash";
import moment from 'moment-jalaali';
import strings from "../../utils/strings";
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import axiosInstance from '../../axios';
import config from '../../config';
import ShowSeoHistory from './ShowSeoHistory';

const { Search } = Input;
export default function Seo() {

    const { business, auth, getBusinesses, getBusinessHeads, filterSeo, deleteHead, setSelectedHead } = usePersistedStore();
    const general = useGeneralStore()
    const navigate = useNavigate();
    const loading = business.businesses.loading;
    const businesses = business.businesses.all;
    const getAllBusinussArray = businesses => Object.keys(businesses).map(token => businesses[token])
    const allBusinussArray = getAllBusinussArray(businesses)
    const [whichSelected, setWhichSelected] = useState(-1)
    const heads = business.businesses.selectedHeads;
    const filteredSeo = business.businesses.filteredSeo;
    const businessToken = business.currentBusiness.token;
    const [isLoading, setIsLoading] = useState(false)
    const [seoHistory, setSeoHistory] = useState([])


    const userbusiness = allBusinussArray && allBusinussArray.filter(business => business.token === businessToken)
    const businessTkn = userbusiness[0] && userbusiness[0].token;
    // const businessId = userbusiness[0] && userbusiness[0].id;
    const userInfo = auth.userInfo;
    let userResources = userInfo?.Resources;

    // console.log({whichSelected})
    const showPopUpDetailsSEO = async(id)=>{
        setWhichSelected(id?.id)
        setIsLoading(true)
        const url = `/v1/business/head-History/${id?.id}`
        await axiosInstance({
            method: "get",
            baseURL: config.apiUrls(),
            url: url,
            // headers: {
            //     Token: "da4aa2f8-70d9-4d56-b577-3162dfae2c0f",
            //     authentication: `Bearer ${auth.userToken}`
            // },
        })
            .then(async(resp) => {
            // console.log({resp})
            const {data} = await resp.data
            setIsLoading(false)
            setWhichSelected(-1)
            if(data.length){
                
                setSeoHistory(data)
                general.ToggleSeoHistoryModal()
            }else{
                message.error("تاریخچه ای برای این آدرس وجود ندارد")
            }
            })
            .catch(e => {
                setWhichSelected(-1)
                // console.log({e})
                setIsLoading(false)
            })
        // console.log({url, businessTkn, userInfo }, auth.userToken)
    }
    // console.log({seoHistory})
    useEffect(() => {
        if (!businessToken)
            navigate('/dashboard');
        if (isEmpty(businesses))
            getBusinesses();
        businessTkn && getBusinessHeads(businessTkn)
    }, [businessTkn, businessToken, navigate])

    

    const columns = [
        {
            title: "آدرس",
            dataIndex: "url",
            key: "url",
            width: 100,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "عنوان",
            dataIndex: "title",
            key: ["title", "id"],
            width: 100,
            render: (text,id) => <span>{text}</span>,
        },
        {
            title: "توضیحات",
            dataIndex: "description",
            key: "description",
            width: 600,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "متا تگ ها",
            dataIndex: "metaTags",
            width: 200,
            key: "metaTags",
            render: (text) => <span>{text}</span>,
        },
        {
            title: "کنونیکال",
            dataIndex: "canonical",
            key: "canonical",
            width: 100,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "فالو",
            dataIndex: "followStatus",
            width: 200,
            key: "followStatus",
            render: (text) => {

                return (<div>
                    <span>{text == null && "مقدار پیش فرض"}</span>
                    <span>{text == 0 && "NoFollow"}</span>
                    <span>{text == 1 && "Follow"}</span>
                </div>
                )
            }

        },
        {
            title: "تاریخ ویرایش",
            dataIndex: "updatedAt",
            key: "updatedAt",
            width: 150,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.updatedAt ? first = a.updatedAt : first = '';
                b.updatedAt ? second = b.updatedAt : second = '';
                return first.localeCompare(second)
            },
            render: data => strings.getFarsiNum(moment(data).format(" jYYYY/jMM/jDD  ساعت:  HH:mm  "))
        },
        {
            title: "عملیات",
            dataIndex: "operation",
            key: "operation",
            width: 100,
            render: (_, record) =>
                allBusinussArray.length >= 1 && (
                    <Space size="middle">
                        {userResources && userResources.includes("BusinessAdmin") &&
                            <Popconfirm
                                title="آیا از حذف صفحه اطمینان دارید؟"
                                onConfirm={() => deleteHead({ headId: record.id, businessId: businessTkn })}
                                okText="تایید"
                                cancelText="انصراف">
                                <button type="danger" className="btn btn-danger btn-sm waves-effect waves-light">
                                    <i className="fas fa-minus font-size-16 align-middle mr-2"></i> حذف
                                </button>
                            </Popconfirm>}
                        <button type="dashed" className="btn btn-info btn-sm waves-effect waves-light"
                            onClick={() => {
                                general.ToggleSeoEditModal()
                                setSelectedHead(record)
                            }}>
                            <i className="far fa-edit font-size-16 align-middle mr-2"></i> ویرایش
                            </button>
                            {
                                record?.id === whichSelected ?
                                <button type="warning" style={{width: "60px", height: "45px"}}  className="btn btn-primary btn-sm waves-effect waves-light"
                                >
                                
                                    <Spin loading></Spin>
                            </button>
                            :

                            <button type="warning" className="btn btn-primary btn-sm waves-effect waves-light"
                                disabled={isLoading}
                                onClick={() => {
                                    showPopUpDetailsSEO(record)
                                }}>
                                <i className="fa fa-list font-size-16 align-middle mr-2"></i> تاریخچه
                            </button>
                        }
                    </Space>
                ),
        },
        // {
        //     title: "عملیات",
        //     dataIndex: "operation",
        //     key: ["operation", "id"],
        //     width: 100,
        //     render: (record,id) =>
        //         allBusinussArray.length >= 1 && (
        //             <Space size="middle">
        //                 {userResources && userResources.includes("BusinessAdmin") &&
        //                     <Popconfirm
        //                         title="آیا از حذف صفحه اطمینان دارید؟"
        //                         onConfirm={() => deleteHead({ headId: record.id, businessId: businessTkn })}
        //                         okText="تایید"
        //                         cancelText="انصراف">
        //                         <button type="danger" className="btn btn-danger btn-sm waves-effect waves-light">
        //                             <i className="fas fa-minus font-size-16 align-middle mr-2"></i> حذف
        //                         </button>
        //                     </Popconfirm>}
        //                     <button type="dashed" className="btn btn-info btn-sm waves-effect waves-light"
        //                         onClick={() => {
        //                             general.ToggleSeoEditModal()
        //                             setSelectedHead(record)
        //                         }}>
        //                     <i className="far fa-edit font-size-16 align-middle mr-2"></i> ویرایش
        //                     </button>
        //                     {
        //                         id?.id === whichSelected ?
        //                         <button type="warning" style={{width: "60px", height: "45px"}}  className="btn btn-primary btn-sm waves-effect waves-light"
        //                         >
                                
        //                             <Spin loading></Spin>
        //                     </button>
        //                     :

        //                     <button type="warning" className="btn btn-primary btn-sm waves-effect waves-light"
        //                         disabled={isLoading}
        //                         onClick={() => {
        //                             showPopUpDetailsSEO(id)
        //                         }}>
        //                         <i className="fa fa-list font-size-16 align-middle mr-2"></i> تاریخچه
        //                     </button>
        //                 }
        //             </Space>
        //         ),
        // },
    ];

    const handleSearch = (e) => {
        if (heads) (filterSeo({ value: e.target.value, all: heads }));
    };
    return (
        <Card className="seo-card">
            <div className="alert alert-info alert-dismissible fade show mb-0" role="alert">
                <i className="mdi mdi-alert-circle-outline mr-2"></i> آدرس را بدون درنظر گرفتن دامنه وارد کنید. <strong className="important-text">بطور مثال برای وارد کردن آدرس اصلی تنها از '/' استفاده کنید.</strong><br />
                همچنین از پاک کردن روت اصلی (/) در <strong className="important-text">bimeh.com</strong> خودداری نمایید.
            </div>
            <Search
                className="table-search"
                placeholder="جستجو بر اساس آدرس و عنوان "
                onChange={handleSearch}
            />
            {businessToken &&
                <button type="primary" className="btn btn-primary waves-effect waves-light float-left"
                    onClick={() => general.ToggleSeoModal()} style={{ marginBottom: "20px" }}>
                    <i className="fas fa-file-medical font-size-14 align-middle mr-2"></i>افزودن صفحه
                </button>
            }
            <Table

                className="custom-table"
                style={{ paddingTop: "20px", overflowX: "scroll" }}
                bordered
                columns={columns}
                loading={loading}
                dataSource={filteredSeo}
                // dataSource={heads}
                scroll={true}
                rowKey="url"
            />
            <AddSeo businessToken={businessTkn} />
            <EditSeo businessToken={businessTkn} />

            <ShowSeoHistory businessToken={businessTkn} setSeoHistory={setSeoHistory} seoHistory={seoHistory}/>
        </Card>
    )
}
